import * as _ from "lodash";

const url = window.location.href;
const testRegex = /^https?\:\/\/.*:809[01].*$/;

const isTestStage = testRegex.test(url) || url.includes("test");

const getApiHost = () => "/api";

export default {
  getApiHost,
  isTestStage: () => isTestStage,
};



// WEBPACK FOOTER //
// ./src/services/Host.ts